module.exports = __webpack_public_path__ + "static/img/son14.993bd4c9.png";